<script>
  export { className as class }

  let className = ""
</script>

<article class="{className} pt-12 pb-20 md:pb-[120px]">
  <slot />
</article>
